import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery-touchswipe';

// handle hover for touch devices in css
if (!("ontouchstart" in document.documentElement)) {
  document.documentElement.className += " no-touch";
}

require('./modules/main');
require('./tools/utils');